import { CapIQ, PublicComp } from 'pages/ValuationsAllocation/types';
import { GPCAttributes } from './types';

type GetFlattenedDataProps = {
  data: PublicComp;
  attributes: GPCAttributes;
};

type FlattenedData = { [key: string]: string | number | boolean };

const getFlattenedData = ({ data, attributes }: GetFlattenedDataProps) =>
  Object.keys(data).reduce<FlattenedData>((flattenedObj: any, key: string) => {
    const { value } = data[key as keyof PublicComp] as CapIQ;
    const attribute = attributes[key as keyof GPCAttributes];
    // eslint-disable-next-line no-param-reassign
    flattenedObj[key]
      = typeof value === 'number' && attribute
        ? parseFloat(value.toString()).toFixed(Number(attribute.decimal_places))
        : value;
    return flattenedObj;
  }, {});

export default getFlattenedData;
